/* StencilJS Bento Grid Component Styles - Converted from SCSS with hardcoded values */

vs-bento-grid {
  display: block;
  font-family:
    'Visa Dialect',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;
}

/* Reset for heading elements to prevent browser default styles */
vs-bento-grid h3 {
  margin: 0;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
}

/* Theme Variables */
.bentogrid-container.theme-light {
  --bento-grid-text-heading: #1a1a1a;
  --bento-grid-text-subtitle: #656565;
  --bento-grid-text-button: #1a1a1a;
  --bento-grid-border-button: #1a1a1a;
  --color-bg-primary: #ffffff;
}
.bentogrid-container.theme-dark {
  --bento-grid-text-heading: #ffffff;
  --bento-grid-text-subtitle: #dedede;
  --bento-grid-text-button: #ffffff;
  --bento-grid-border-button: #ffffff;
  --color-bg-primary: #181b1d;
}

.bentogrid-container {
  background-color: var(--color-bg-primary);
  max-width: 1600px;
  margin: 0 auto;
  padding-left: 40px; /* Default padding-left for Grid L */
}

.bentogrid-title-block {
  margin: 3rem 0;
}

.bentogrid-title-block .bentogrid-title {
  flex: 0 0 52%;
  align-items: flex-start;
  display: flex;
  max-width: calc(50% + 1.5%);
  color: var(--bento-grid-text-heading);
  font-size: 48px;
  font-weight: 400;
  line-height: 1.2;
  margin: 0;
}

@media (max-width: 1023px) {
  .bentogrid-title-block .bentogrid-title {
    flex-direction: column;
    margin-right: 0;
    margin-bottom: 1.5rem;
    font-size: 36px;
  }
}

@media (max-width: 1023px) {
  .bentogrid-title-block {
    margin: 1.5rem 0;
  }
}

.bentogrid-subtitle-container {
  flex: 1;
}

.bentogrid-subtitle {
  color: var(--bento-grid-text-subtitle);
  margin-bottom: 1.5rem;
  max-width: 600px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.bentogrid-button-group {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

.bentogrid-link-button {
  font-family: 'Visa Dialect', sans-serif;
  font-size: 14px;
  font-weight: 400;
  padding: 0.75rem 1.5rem;
  border-radius: 1000px;
  cursor: pointer;
  text-align: center;
  border: 1px solid var(--bento-grid-border-button);
  background-color: transparent;
  color: var(--bento-grid-text-button);
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s;
  text-decoration: none;
  display: inline-block;
}

.bentogrid-link-button:hover {
  background-color: #ffffff;
  color: #1a1a1a;
}

.bentogrid-link-button:focus {
  outline: 2px solid #0066cc;
  outline-offset: 2px;
}

.bentogrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 42px;
}

.bentogrid-container .vsr-title-container.padding + .bentogrid {
  margin-top: 0;
}

.bentogrid-column {
  display: flex;
  flex-direction: column;
  gap: 41px;
}

/* Grid L (>1200px) */
@media (min-width: 1200px) {
  .bentogrid-container {
    padding: 48px 40px;
  }

  .bentogrid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 42px;
  }

  .bentogrid-container .vsr-title-container.padding + .bentogrid {
    margin-top: 0;
  }

  .bentogrid-column {
    gap: 41px;
  }
}

/* Grid M (992px <> 1199px) */
@media (min-width: 992px) and (max-width: 1199px) {
  .bentogrid-container {
    padding: 48px;
  }

  .bentogrid {
    grid-template-columns: repeat(2, 1fr);
    gap: 23px;
    margin-top: 37px;
  }

  .bentogrid-column {
    gap: 29px;
  }
}

/* Grid S (768px <> 991px) */
@media (min-width: 768px) and (max-width: 991px) {
  .bentogrid-container {
    padding: 48px 32px;
  }

  .bentogrid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-top: 39px;
  }

  .bentogrid-column {
    gap: 26px;
  }

  .bento-card-headline,
  h3.bento-card-headline {
    font-size: 24px;
  }
}

/* Grid XS (<768px) */
@media (max-width: 767px) {
  .bentogrid-container {
    padding: 30px 6.4% 30px 9.6%;
  }

  .bentogrid-mobile {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 48px;
  }

  .bentogrid-column {
    gap: 24px;
  }
  .bentogrid-mobile .bento-card-text {
    margin-bottom: 1rem;
  }
}

.bento-card {
  position: relative;
  overflow: hidden;
  padding: 4.75rem; /* Base padding for cards without media - matches absolute positioning percentages */
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* box-shadow: 1px 1px 4px 2px rgba(0, 0, 0, 0.1); */
  transition:
    transform 0.3s ease,
    box-shadow 0.2s;
  background-color: #ebecf1;
  box-sizing: border-box;
}

/* Cards with background images or videos should have no padding since content is absolutely positioned 
   The absolute positioning uses percentages (9% left/right, 7% top) that visually match the 4.75rem padding */
.bento-card.has-background-image,
.bento-card.has-video {
  padding: 0;
}

/* Hover effect commented out
.bento-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}
*/

.bento-card-content {
  z-index: 2;
  position: relative;
}

.bento-card-text {
  margin-bottom: 1.5rem;
}

.bento-card-eyebrow {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  display: block;
  margin-bottom: 0.5rem;
  text-transform: capitalize;
  letter-spacing: 0.05em;
  opacity: 0.8;
}

.bento-card-headline,
h3.bento-card-headline {
  font-size: 32px;
  font-weight: 400;
  line-height: 1.25;
  margin: 0 0 1rem 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  text-transform: none;
  color: inherit;
}

.bento-card-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.01em;
}

.bento-card-description p {
  margin: 0 0 1rem 0;
}

.bento-card-description p:last-child {
  margin-bottom: 0;
}

.button-group {
  margin-top: 1.5rem;
}

.bento-card-button {
  font-family: 'Visa Dialect', sans-serif;
  font-size: 14px;
  font-weight: 400;
  padding: 0.75rem 1.5rem;
  border-radius: 1000px;
  cursor: pointer;
  text-align: center;
  border: 1px solid #1a1a1a;
  background-color: transparent;
  color: #1a1a1a;
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s;
  text-decoration: none;
  display: inline-block;
}

.column-left .bento-card-button {
  color: #ffffff;
  border: 1px solid #ffffff;
}

.bento-card-button:hover {
  background-color: #ffffff;
  color: #1a1a1a;
}

.bento-card-button:focus {
  outline: 2px solid #0066cc;
  outline-offset: 2px;
}

.bentogrid .bento-card {
  flex: 0 0 auto;
}

/* Card size variations for grid layout No Filp*/

.bentogrid .bentogrid-column:first-child .bento-card:first-child {
  min-height: 648px;
}

/* .bentogrid .column-right .bento-card:last-child {
  aspect-ratio: 1/1;
} */

.bentogrid .bentogrid-column:first-child .bento-card:last-child {
  min-height: 888px;
}

/* Right column */
.bentogrid .bentogrid-column:last-child .bento-card:first-child {
  min-height: 888px;
}

.bentogrid .bentogrid-column:last-child .bento-card:last-child {
  min-height: 648px;
}

/* Card size variations for grid layout  Filp*/
.bentogrid.flip .bentogrid-column:first-child .bento-card:first-child {
  min-height: 888px;
}
.bentogrid.flip .bentogrid-column:first-child .bento-card:last-child {
  min-height: 648px;
}
.bentogrid.flip .bentogrid-column:last-child .bento-card:first-child {
  min-height: 648px;
}
.bentogrid.flip .bentogrid-column:last-child .bento-card:last-child {
  min-height: 888px;
}

.bentogrid.flip .bento-card {
  flex: 1 1 auto; /* Equal flex growth for all cards */
}

.bentogrid.flip .bentogrid-column:first-child .bento-card:first-child {
  min-height: 888px; /* was last-child height */
  flex: 2;
}

.bentogrid.flip .bentogrid-column:first-child .bento-card:last-child {
  min-height: 648px; /* was first-child height */
  flex: 1;
}

@media (max-width: 767px) {
  .bentogrid .bentogrid-column:first-child .bento-card:first-child,
  .bentogrid .bentogrid-column:first-child .bento-card:last-child {
    min-height: 400px; /* same as mobile */
  }
}

@media (max-width: 767px) {
  .bentogrid.flip .bentogrid-column:first-child .bento-card:first-child,
  .bentogrid.flip .bentogrid-column:first-child .bento-card:last-child {
    min-height: 400px; /* same as mobile */
  }
}

@media (max-width: 767px) {
  .bentogrid .bentogrid-column:last-child .bento-card:first-child,
  .bentogrid .bentogrid-column:last-child .bento-card:last-child {
    min-height: 400px; /* same on mobile */
  }
}

@media (max-width: 767px) {
  .bentogrid.flip .bentogrid-column:last-child .bento-card:first-child,
  .bentogrid.flip .bentogrid-column:last-child .bento-card:last-child {
    min-height: 400px; /* same on mobile */
  }
}

/* Staggered layout adjustments */
.column-left .bento-card:first-child {
  margin-top: 0;
}

.column-right .bento-card:first-child {
  margin-top: 0;
}

/* Video background styles */
.bento-card-video-bg {
  pointer-events: none;
  display: block;
}

.bento-card-video-bg:focus,
.bento-card-video-bg:active {
  outline: none !important;
  box-shadow: none !important;
}

.bento-card-video-bg::-moz-focus-inner {
  border: 0;
}

.bento-card-video-gradient-horizontal-highlighted {
  position: absolute;
  left: 0;
  right: 0;
  height: 11px;
  bottom: 39%;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
}

.bento-card-video-gradient-vertical-highlighted {
  position: absolute;
  top: 0;
  right: 0;
  width: 3px;
  height: 60%;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(to left, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
}

.bento-card-video-gradient-horizontal-default {
  position: absolute;
  left: 0;
  right: 0;
  height: 2.5%;
  bottom: -3%;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
}

.bento-card-video-gradient-vertical-default {
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(to left, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
}

/* Left-side gradient masks for balanced visual effect */
.bento-card-video-gradient-vertical-highlighted-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 60%;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
}

.bento-card-video-gradient-vertical-default-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
}

/* Loading and error states */
.loading-skeleton {
  padding: 2rem;
  text-align: center;
  color: #656565;
  font-size: 16px;
}

.error-message {
  padding: 2rem;
  text-align: center;
  color: #cc0000;
  font-size: 16px;
  background-color: #fff5f5;
  border: 1px solid #ffcccc;
  border-radius: 8px;
}

/* Custom styles for vsr-title-headline in bento grid */
.bentogrid-container vsr-title .vsr-title-headline {
  font-size: 40px; /* Desktop font size */
}

/* Custom styles for vsr-title-container in bento grid */
.bentogrid-container .vsr-title-container.padding-horizontal {
  padding-top: 48px;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}

/* Responsive adjustments */
@media (max-width: 767px) {
  /* .bentogrid-container {
    padding: 2rem;
  } */

  .bentogrid-title-block {
    margin: 2rem 0;
  }

  .bentogrid {
    display: none; /* Hide the desktop grid layout */
  }

  .bento-card {
    min-height: 250px;
    height: 500px; /* Default height */
    padding: 4.75rem;
  }

  /* Specific heights for mobile bento grid cards */
  .bentogrid-mobile .bento-card:nth-child(1),
  .bentogrid-mobile .bento-card:nth-child(4) {
    height: 450px; /* First and fourth cards */
  }

  .bentogrid-mobile .bento-card:nth-child(2),
  .bentogrid-mobile .bento-card:nth-child(3) {
    height: 510px; /* Second and third cards */
  }

  /* Cards with media on mobile should also have no padding */
  .bento-card.has-background-image,
  .bento-card.has-video {
    padding: 0;
  }

  /* Ensure background images are centered on mobile */
  .bentogrid-mobile .bento-card[style*='background'] {
    background-position: center center;
  }

  /* Ensure videos are centered on mobile */
  .bentogrid-mobile .bento-card video.bento-card-video-bg {
    object-position: center center;
  }

  .bento-card-headline,
  h3.bento-card-headline {
    font-size: 24px;
  }

  .bentogrid-title {
    font-size: 28px !important;
  }

  /* Show the mobile-specific container */
  .bentogrid-mobile {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
  }

  /* Apply 4:3 aspect ratio to the right first card (second card in mobile view) */
  .bentogrid-mobile .bento-card:nth-child(2) .image-container,
  .bentogrid-mobile .bento-card:nth-child(2) video {
    aspect-ratio: 4/3;
  }

  .bentogrid-container vsr-title .vsr-title-headline {
    font-size: 32px; /* Mobile font size */
  }
}

/* Hide mobile container on desktop */
@media (min-width: 768px) {
  .bentogrid-mobile {
    display: none;
  }
}

/* Accessibility improvements */

/* Screen reader only class */
.vs-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Focus indicator styles with 3:1 contrast ratio */
.bento-card:focus,
.bento-card:focus-visible {
  outline: 3px dotted #0066cc;
  outline-offset: 2px;
}

/* Ensure focus indicators are visible with sufficient contrast */
.bento-card-button:focus,
.bento-card-button:focus-visible {
  outline: 3px dotted #0066cc;
  outline-offset: 2px;
}

/* Remove underline from buttons on hover */
.bento-card vsr-button-v2 a:hover,
.bento-card vsr-button-v2 button:hover {
  text-decoration: none !important;
}

/* Text spacing adjustments for content reflow */
.bento-card-description p {
  line-height: 1.5;
  margin-bottom: 1rem;
  max-width: 100%;
  overflow-wrap: break-word;
}

/* Ensure proper text spacing for accessibility */
@media (prefers-reduced-motion: reduce) {
  .bento-card {
    transition: none;
  }

  .bento-card:hover {
    transform: none;
  }

  .bentogrid-link-button,
  .bento-card-button {
    transition: none;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .bento-card {
    border: 2px solid #000000;
  }

  .bentogrid-link-button,
  .bento-card-button {
    border-width: 3px;
  }
}
